import ContactInfo from './ContactInfo';
import Task from './Task';
export default class Employer {
  public firstName: string = '';
  public lastName: string = '';
  public description: string = '';
  public availableTasks: Task[] = [];
  public rating: number = 0;
  public photo: string = '';
  public email: string;
  public userEmail: string;
  public contactInfo: ContactInfo;
  public ktp: string;
}
